import {
  Button,
  ButtonSize,
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { ArrowLeft } from "untitledui-js-base";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { StepNames } from "../constants";

export const IframeLayout = ({
  activeStepName,
  setActiveStepName,
  children,
  stepNames,
  setOpen,
  noBack,
  goBack
}: {
  activeStepName: string;
  setActiveStepName: (stepName: string) => void;
  children: React.ReactNode;
  stepNames: string[];
  setOpen: (value: boolean) => void;
  noBack?: boolean;
  goBack?: () => void;
}) => {
  return (
    <div className="flex-1 min-w-0">
      <div className="h-[72px] border-b border-alpha-100 flex items-center justify-between px-2">
        {noBack ? (
          // Leaving this here to preserve the layout space
          <div />
        ) : (
          <Button
            borderLess
            size={ButtonSize.SM}
            onClick={() => {
              if (goBack) goBack();
              else {
                const currentIdx = stepNames.indexOf(activeStepName!);
                const nextIdx = currentIdx - 1;

                if (nextIdx >= 0) setActiveStepName(stepNames[nextIdx]);
              }
            }}
            Icon={ArrowLeft}
          >
            Back
          </Button>
        )}
        <h1 className="text-base font-bold text-content-1000 text-center -translate-x-6">
          {StepNames[activeStepName || ""]}
        </h1>

        <IconButton
          HugeIcon={Cancel01Icon}
          variant={IconButtonVariant.TEXT_BASE}
          size={IconButtonSize.SM}
          onClick={() => {
            setOpen(false);
          }}
        />
      </div>
      {children}
    </div>
  );
};
